module.exports = __webpack_public_path__ + "static/img/case-2.4e7899d2.png";